import React, { useState } from "react"
import "../../style/Home/bodyHome.css"
import { Row, Col, Button, Card } from "react-bootstrap"
import usePost from "../../hooks/usePost"

import { connect } from "react-redux"
import { getData } from "../../utils/page.js"
import Image from "gatsby-image"
import styled from "styled-components"
import mobileMaxWidth from "../../utils/page"
import { ReadLink } from "../../components/Blog/ReadLink"

const { Body, Title, Text } = Card

let Blog = props => {
  const [visible, setVisible] = useState(3)
  const posts = usePost()
  const {
    app: { lang },
    location,
  } = props
  const orderMap = posts
    .sort((a, b) => (a.order > b.order ? 1 : a.order < b.order ? -1 : 0))
    .reverse()
  const content = getData(location, lang)

  const BlogImage = styled(Image)`
    margin-top: 0;
    padding: 0;
    position: relative;
    overflow: hidden;
    height: 100%;
    /*  max-width: 400px;
    max-height: 600px; */

    @media (min-width: ${mobileMaxWidth}) {
      height: auto;
      /*  max-width: 400px;
      max-height: 600px; */
    }
  `

  const loadMore = () => {
    setVisible(visible + 3)
  }

  return (
    <>
      <Row
        className={`justify-content-center text-porfolio ${props.classAnimationFooter} `}
      >
        <Col
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          className={`${props.classAnimationPortfolio} `}
          style={{ textAlign: "center" }}
        >
          <h1 className="portfolio-title">{content.sectionBlog.blogTitle}</h1>
        </Col>
      </Row>
      <Row
        className={`justify-content-center ${props.classAnimationPortfolio} col-blog-cards`}
      >
        {posts.slice(0, visible).map((post, index) => {
          return (
            <div
              className="col-12 col-sm-12 col-md-8 col-lg-4 col-xl-3 item-carousel"
              key={index}
            >
              <ReadLink to={`/blog/${post.slug}`}>
                <CardBlog
                  style={{
                    width: "100%",
                  }}
                >
                  <div className="inner">
                    <BlogImage
                      fluid={post.image.sharp.fluid}
                      alt={post.title}
                    />
                  </div>
                  <Body className="card-body-portfolio">
                    <Title style={{ fontWeight: "bold", marginBottom: "1rem" }}>
                      {post.title}
                    </Title>
                    <Text>{post.excerpt.slice(0, 60) + "..."}</Text>
                    <Text className="area-text-home">{post.tag}</Text>
                  </Body>
                </CardBlog>
              </ReadLink>
            </div>
          )
        })}
      </Row>
      <Row
        className={`justify-content-center ${props.classAnimationPortfolio} `}
      >
        {visible < posts.length && (
          <Button onClick={() => loadMore()} className="btn-loadMore-home">
            {" "}
            {content.sectionBlog.common.loadMore}
          </Button>
        )}
      </Row>
    </>
  )
}

const mapStateToProps = state => {
  return state
}

const mapDispatchToProps = dispatch => {
  return {
    changeLang: lang => dispatch({ type: "SET_LANGUAGE", payload: lang }),
  }
}

Blog = connect(mapStateToProps, mapDispatchToProps)(Blog)
export default Blog

const CardBlog = styled.div`
  /*  margin-right: 1rem !important;
  margin-left: 1rem !important; */
  margin-top: 3rem !important;
  width: 100% !important;
  background-color: white;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
  min-height: 307px !important;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  transition: all 0.65s;

  :hover {
    transform: translateY(20px);
  }
`
